"use strict";

import angular from "angular";

import template from "./remember-shared.component.html";
import "./remember-shared.component.scss";

import _ from "lodash";
import { Report } from "../../../gateway/Report/Report";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import { EventScoreService } from "../../../presentation/services/Score/event-score.service";
import { ShareHistory } from "../../../presentation/services/ShareHistory/ShareHistory";
import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";
import { GetUserUsecase } from "../../../usecases";
import { AnonymousUser } from "../../../utils/users-roles/users-roles";
import { dialogShareTemplate } from "../../../views/accounting/company/reports/reports.dialog-templates";
export class rememberSharedComponent {
    constructor($mdDialog, DSNDialogService, $stateParams, $mdMedia) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.$stateParams = $stateParams;
        this.$mdMedia = $mdMedia;

        this.Report = new Report();
        this.ShareHistory = new ShareHistory({
            Report: this.Report
        });

        this.Events = new Events();
        this.User = new User();
        this.EventScore = new EventScoreService();

        this.user = new UserDataAdapter().user();
        this.valueMediaScreen = "max-width: 600px";

        this.isAnonymous = _.get(this.user, "profile.anonymous");
    }
    $onInit() {}

    openShareEmail() {
        this.DSNDialogService.hide();
        this.DSNDialogService.custom({
            clickOutsideToClose: false,
            controller: "DialogShareCtrl as $ctrl",
            fullscreen: this.$mdMedia(this.valueMediaScreen),
            locals: {
                width: "746px",
                report: this.report,
                title: "Compartilhar por Email",
                accountingId: this.accountingId,
                company: this.companyData,
                templateHtml: dialogShareTemplate
            },
            after: {
                hide: (response) => {
                    if (response) {
                        this.EventScore.onReportShared(
                            this.$stateParams.accountingId,
                            this.companyData._id,
                            this.report.sources
                        );
                    }
                }
            }
        });
    }

    async _generateToken() {
        const getUserUsecase = new GetUserUsecase();
        const userAnonymous = await getUserUsecase.execute({
            username: AnonymousUser.email
        });
        const token = userAnonymous.getLastToken();
        return { token, userAnonymous: userAnonymous.props };
    }

    async sendWhatSapp() {
        this.DSNDialogService.hide();
        const { token, userAnonymous } = await this._generateToken();

        const baseUrl = publicSettings.url;

        const uri = `${baseUrl}/relatorio/${this.$stateParams.id}/${
            this.$stateParams.accountingId
        }/${this._typeReport()}/${userAnonymous._id}/${
            this.$stateParams.reportId
        }?liveToken=${token}`;

        this.Events.send(
            `Relatorio.Compartilhar.Whatsapp.${SourceConvert.toHuman(
                this.report.sources
            )}`
        );

        this.EventScore.onReportShared(
            this.$stateParams.accountingId,
            this.companyData._id,
            this.report.sources
        );

        this.ShareHistory.setReportShareHistory(
            "whatsapp",
            this.report._id,
            "USER_WHATSAPP"
        );
        const whatsappAPI = "https://api.whatsapp.com/send?text=";
        window.open(
            `${whatsappAPI} Olá, confira o Dash que preparei da ${new URLSearchParams(
                this.companyData.name
            ).toString()} Clique no link abaixo para visualizar:\n ${uri}`
        );
    }

    print() {
        this.ShareHistory.setReportShareHistory(
            "donwload",
            this.report._id,
            "USER_DOWNLOAD"
        );

        this.$mdDialog.hide(true);
        setTimeout(() => {
            this.onPrint();
        }, 400);
    }

    _typeReport() {
        let source = "";
        switch (this.report.type) {
            case "monitoring":
                source = "regras";
                break;
            case "balance":
                source = "balanco";
                break;
            default:
                source = this.report.type;
                break;
        }
        return source;
    }
}
rememberSharedComponent.$inject = [
    "$mdDialog",
    "DSNDialogService",
    "$stateParams",
    "$mdMedia"
];

const name = "rememberSharedReports";
const def = {
    controller: rememberSharedComponent,
    bindings: {
        imageUrl: "@",
        title: "@",
        report: "=",
        source: "<",
        companyData: "<",
        accountingId: "<",
        onPrint: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
